import React from 'react';
import {
  Box,
  Typography,
  Button,
} from '@mui/material';
import {
  Bolt as FlashIcon,
  Refresh as RefreshIcon,
  MusicNote as MusicIcon,
} from '@mui/icons-material';
import InstaQuizShell from './InstaQuizShell';
import InstaQuizHeroHeader from './InstaQuizHeroHeader';
import {
  instaQuizPrimaryButtonSx,
  INSTA_QUIZ,
} from './instaQuizTheme';

const FlashQuizNotAvailable = ({ onBack, onRefresh, onPractice }) => {
  return (
    <InstaQuizShell onBack={onBack} title="Insta Quiz">
      <Box
        sx={{
          width: '100%',
          maxWidth: 640,
          mx: 'auto',
          px: { xs: 1, sm: 2 },
        }}
      >
        <InstaQuizHeroHeader
          variant="waiting"
          title="The stage is quiet… for now"
          subtitle="No live Insta Quiz is running at the moment — but stick around! The moment our host hits play, we'll whisk you straight into the action."
        />

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            mb: 4,
            py: 1.5,
            px: 2,
            borderRadius: 2,
            bgcolor: 'rgba(0,0,0,0.25)',
            border: '1px solid rgba(255,255,255,0.06)',
          }}
        >
          <FlashIcon sx={{ color: INSTA_QUIZ.purple, fontSize: 20, flexShrink: 0 }} />
          <Typography
            variant="body2"
            sx={{ color: 'rgba(255,255,255,0.55)', textAlign: 'center', lineHeight: 1.5 }}
          >
            This page refreshes automatically when a session goes live
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            gap: 2,
            justifyContent: 'center',
            flexWrap: 'wrap',
            alignItems: 'center',
          }}
        >
          {onRefresh && (
            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={onRefresh}
              sx={{
                borderColor: INSTA_QUIZ.cardBorder,
                color: INSTA_QUIZ.purpleLight,
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: '999px',
                px: 3,
                '&:hover': {
                  borderColor: INSTA_QUIZ.purple,
                  bgcolor: 'rgba(156,39,176,0.1)',
                },
              }}
            >
              Check again
            </Button>
          )}
          {onPractice && (
            <Button
              variant="contained"
              startIcon={<MusicIcon />}
              onClick={onPractice}
              sx={{
                ...instaQuizPrimaryButtonSx,
                background:
                  'linear-gradient(135deg, rgba(156,39,176,0.5) 0%, rgba(126,87,194,0.6) 100%)',
              }}
            >
              Try Demo Mode
            </Button>
          )}
          <Button
            variant="text"
            onClick={onBack}
            sx={{
              color: 'rgba(255,255,255,0.5)',
              textTransform: 'none',
              fontWeight: 500,
              '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.05)' },
            }}
          >
            Back to the fun
          </Button>
        </Box>

        {onPractice && (
          <Typography
            variant="caption"
            sx={{ color: 'rgba(255,255,255,0.35)', display: 'block', mt: 3, textAlign: 'center' }}
          >
            New here? Demo Mode lets you practice with sample questions while you wait.
          </Typography>
        )}
      </Box>
    </InstaQuizShell>
  );
};

export default FlashQuizNotAvailable;
